import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/app.css';
import BackToTop from 'vue-backtotop';
import reveal from './directives/reveal';
import parallax from './directives/parallax';

const feather = require('feather-icons');
feather.replace();

createApp(App)
	.use(router)
	.use(BackToTop)
	.directive('reveal', reveal)
	.directive('parallax', parallax)
	.mount('#app');

document.querySelector('body').classList.add('bg-primary-dark');
